"use client";
import { SeriesSummaryModel, SiteSettingModel } from "@api/models";
import Description from "./Description";
import Link from "next/link";
import { MdClose } from "react-icons/md";
import { useState } from "react";
import { SeriesHeaderFanletterBtn } from "./SeriesHeaderFanletterBtn";

export function SeriesHeaderDescription({
  series,
  mode,
  siteSettings,
}: {
  series: SeriesSummaryModel;
  mode?: "ep";
  siteSettings: SiteSettingModel;
}) {
  const [isDescOpen, setIsDescOpen] = useState<boolean>(false);

  return (
    <div className="series-h-credit-info-text-wrap">
      <div className={"series-h-credit-info-text" + (isDescOpen ? "" : " mode-hidden")}>
        <div className="series-h-credit-info-text-text">
          <Description
            body={series.description}
            descriptionType={series.descriptionType}
          ></Description>
        </div>

        <div className="series-h-tags">
          {series.tag?.map((tag) => (
            <Link href={`/genre/${tag.id}`} key={tag.id} className="series-h-tag-link">
              <span className="series-h-tag-label">#{tag.name}</span>
            </Link>
          ))}
        </div>

        {mode !== "ep" && siteSettings.fanLetterLink && (
          <SeriesHeaderFanletterBtn series={series} siteSettings={siteSettings} />
        )}

        <a
          className="series-h-credit-close"
          onClick={() => {
            setIsDescOpen(false);
          }}
        >
          <MdClose />
        </a>
      </div>
      <div className="series-h-credit-button">
        <a
          className="series-h-credit-button-link"
          onClick={() => {
            setIsDescOpen(!isDescOpen);
          }}
        >
          作品情報
        </a>
      </div>
    </div>
  );
}
